<section class="business-registration-testimonial-section">
  <div class="container">
    <div class="partner-topic">
      <div
        class="partner-topic__heading partner-topic__heading--desktop color-gray"
        [innerHTML]="'BUSINESS_REGISTRATION.TESTIMONIAL.HEADING' | translate"
      >
      </div>
    </div>

    <div class="content-section">
      <div class="swiper-container-main">
        <swiper-container class="swiper" appSwiper [config]="config" init="false">
          <ng-container *ngFor="let item of testimonialList">
            <swiper-slide class="swiper-slide">
              <div class="partner-testimonial-card">
                <div class="card-top card-top--desktop">
                  {{ translate.currentLang === 'th' ? item.data.SpeakerQuote.th : item.data.SpeakerQuote.en }}
                </div>

                <div class="card-bottom">
                  <div class="speaker">
                    <div class="speaker__image-cover">
                      <picture>
                        <source [srcset]="item.data.imageWebP.iv" type="image/webp" />

                        <img
                          [src]="item.data.image.iv"
                          width="100%"
                          loading="lazy"
                          class="card__image"
                          [alt]="translate.currentLang === 'th' ? item.data.speakerName.th : item.data.speakerName.en"
                          [title]="translate.currentLang === 'th' ? item.data.speakerName.th : item.data.speakerName.en"
                        />
                      </picture>
                    </div>
                    <div class="speaker__detail">
                      <div class="speaker__detail-name">
                        {{ translate.currentLang === 'th' ? item.data.speakerName.th : item.data.speakerName.en }}</div
                      >

                      <div class="speaker__detail-position">{{
                        translate.currentLang === 'th' ? item.data.speakerJob.th : item.data.speakerJob.en
                      }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </ng-container>
        </swiper-container>
        <div class="swiper-button-prev">
          <i class="cursor fas fa-arrow-left"></i>
        </div>
        <div class="swiper-button-next">
          <i class="cursor fas fa-arrow-right"></i>
        </div>
      </div>
    </div>
  </div>
</section>
